<script setup lang="ts">
/** Pins what it sits on to the topbar, or unpins it. The same button on a
 *  task's drawer, a terminal and a queued prompt. */
import { computed } from "vue";
import { useViewport } from "../stores/viewport.js";
import type { Pin } from "@shared/settings.js";
import PinIcon from "./PinIcon.vue";

const props = defineProps<{ pin: Pin; name: string }>();
const viewport = useViewport();
const on = computed(() => viewport.isPinned(props.pin));
</script>

<template>
  <button
    class="pin-btn"
    :class="{ on }"
    type="button"
    :aria-pressed="on"
    :title="on ? `Unpin ${name} from the top bar` : `Pin ${name} to the top bar`"
    :aria-label="on ? `Unpin ${name}` : `Pin ${name}`"
    @click.stop="viewport.togglePin(pin)"
  >
    <PinIcon :filled="on" />
  </button>
</template>
